import {createContext} from "react";
import {noop} from "shared/helpers/utils/noop";
import type {AppMenuContextValue} from "./types";

const defaultValue: AppMenuContextValue = {
  onClick: noop,
};

export const AppMenuContext = createContext<AppMenuContextValue>(defaultValue);